import React from "react";
import './offers.scss'

export const Offers: React.FC = () => {
    return (
        <div className={'offers'}>

        </div>
    )
}